<ng-container [ngTemplateOutlet]="__group" [ngTemplateOutletContext]="{ $implicit: root }" />

<ng-template #__group let-group>
  @for (row of group.loaded; track $index) {
    <app-table-tile [row]="row" [headers]="headers" />
  }
  @for (subgroup of group.groups; track $index) {
    <ng-container [ngTemplateOutlet]="__group" [ngTemplateOutletContext]="{ $implicit: subgroup }" />
  }
</ng-template>
